import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"
import Accordion from "react-bootstrap/Accordion"

const scoreVariables = `
   playerScore = 0;
   playerScoreText;
   playerLives = 3;
   playerLivesText;
`

const textSnippet = `
     this.playerScoreText = this.add.text(500, 5, "Score: " + this.playerScore, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
     this.playerLivesText = this.add.text(700, 5, "Lives: " + this.playerLives, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
`

const playerEnemyCol = `
     this.physics.add.overlap(
      this.player,
      this.enemies,
      this.playerHitEnemy,
      null,
      this
    );
`

const playerHitEnemySnippet = `
  playerHitEnemy(player, enemy) {
    console.log('boom')
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!enemy.active) {
      return;
    }
    
    this.playerLives--;
    if (this.playerLives <= 0) {
      this.playerScore = 0;
      this.playerLives = 3;
      this.playerScoreText.setText("Score: " + this.playerScore);
    }
      
    this.playerLivesText.setText("Lives: " + this.playerLives);
    
    
    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
`

const bulletHitEnemySnippet = `
    this.playerScore += 100;
    this.playerScoreText.setText("Score: " + this.playerScore);
`

const progressSnippet = `

class MyGame extends Phaser.Scene {
    // Begin our variables 
   cloudsBig;
   cloudsSmall;
   ground;
   hills;
   mountains;
   player;
   cursors;
   playerBullets;
   fireRate = 200;
   nextFireTime = 0;
   enemies;
   enemySpawnRate = 500;
   nextEnemySpawn = 0;
   playerScore = 0;
   playerScoreText;
   playerLives = 3;
   playerLivesText;
   
   // End our variables  
     
   preload() {
     
     this.load.setBaseURL(
       "https://game-course-resources.s3.us-west-2.amazonaws.com"
     );
     // Load background
     this.load.image("clouds-big", "cloudsBig.png");
     this.load.image("clouds-small", "cloudsSmall.png");
     this.load.image("mountains", "Mountains.png");
     this.load.image("hills", "Hills.png");
     this.load.image("ground", "Ground.png");
     this.load.image("bullet", "projectile.png");
     
     // Begin load spritesheets
     this.load.spritesheet("player", "PlayerSpriteSheet.png", {
       frameWidth: 266,
       frameHeight: 122
     });
     
     
    this.load.spritesheet("enemy", "EnemySpriteSheet.png", {
      frameWidth: 266,
      frameHeight: 122
    });
     
     
    this.load.spritesheet("explosion", "explosion.png", {
      frameWidth: 260,
      frameHeight: 260
    });
     // End load spritesheets
   }
   
   create() {
     
     this.mountains = this.add.tileSprite(640, 480, 1280, 400, "mountains");
     this.hills = this.add.tileSprite(640, 480, 1280, 400, "hills");
     this.ground = this.add.tileSprite(640, 520, 1280, 400, "ground");
     this.cloudsBig = this.add.tileSprite(640, 200, 1280, 400, "clouds-big");
     this.cloudsSmall = this.add.tileSprite(640, 200, 1280, 400, "clouds-small");
     
     
     // Begin animation section
     var playerAnimConfig = {
       key: "playerAnimation",
       frames: this.anims.generateFrameNumbers("player", {
         start: 0,
         end: 2,
         first: 0
       }),
       frameRate: 10,
       repeat: -1
     };
   
      this.anims.create(playerAnimConfig);
     
     
    // Create Enemy Animation
    var enemyAnimConfig = {
      key: "enemyAnimation",
      frames: this.anims.generateFrameNumbers("enemy", {
        start: 0,
        end: 2,
        first: 0
      }),
      frameRate: 10,
      repeat: -1
    };

    this.anims.create(enemyAnimConfig);

     
    var explosionAnimConfig = {
      key: "explosionAnimation",
      frames: this.anims.generateFrameNumbers("explosion", {
        start: 0,
        end: 5,
        first: 0
      }),
      frameRate: 10,
      repeat: 0
    };

    this.anims.create(explosionAnimConfig);
     // End animation section
   
     // Begin player logic section
           this.player = this.physics.add
       .sprite(250, 250, "player")
       .play("playerAnimation");
           this.player.setScale(0.4);
     this.player.setCollideWorldBounds(true);
     this.cursors = this.input.keyboard.createCursorKeys();
     // End player logic section
     
     
     // Begin groups section
     this.playerBullets = this.physics.add.group();
     this.playerBullets.createMultiple({
       key: "bullet",
       quantity: 20,
       active: false,
       visible: false
     });
     
     
    this.enemies = this.physics.add.group();
    this.enemies.createMultiple({
      key: "enemy",
      quantity: 15,
      active: false,
      visible: false
    });
     
     // End groups section
     
     //Begin Collisions section
    this.physics.add.overlap(
      this.playerBullets,
      this.enemies,
      this.bulletHitEnemy,
      null,
      this
    );
     
     this.physics.add.overlap(
      this.player,
      this.enemies,
      this.playerHitEnemy,
      null,
      this
    );

     //End Collisions section
     
     // Text Section
     this.playerScoreText = this.add.text(500, 5, "Score: " + this.playerScore, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
     this.playerLivesText = this.add.text(700, 5, "Lives: " + this.playerLives, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
     // End Text Section
     
   }
   
   update(ts, dt) {
     // Begin background logic
     this.cloudsBig.tilePositionX += 0.15;
     this.cloudsSmall.tilePositionX += 0.35;
     this.mountains.tilePositionX += 0.1;
     this.hills.tilePositionX += 0.25;
     this.ground.tilePositionX += 0.45;
     // End backgroun logic
     
     //Begin object cleanup section
     
    this.enemies.children.each((enemy) => {
      if (enemy.x < -50) {
        enemy.disableBody(true, true);
      }
    });

    this.playerBullets.children.each((bullet) => {
      if (bullet.x > 1285) {
        bullet.disableBody(true, true);
      }
    });
     
     //End object cleanup section
     

     
     this.generateEnemy(dt);
     
     // Check player input
     if (this.cursors.left.isDown) {
       this.player.setVelocityX(-160);
     } else if (this.cursors.right.isDown) {
       this.player.setVelocityX(160);
     } else if (this.cursors.up.isDown) {
       this.player.setVelocityY(-160);
     } else if (this.cursors.down.isDown) {
       this.player.setVelocityY(160);
     } else {
       this.player.setVelocityX(0);
       this.player.setVelocityY(0);
     }
     if (this.cursors.space.isDown) {
       this.fire(dt);
     }
   }
     
     //Begin custom functions
     fire(dt) {
       this.nextFireTime -= dt;
       if (this.nextFireTime > 0) {
         return;
       }
       const bullet = this.playerBullets.getFirstDead();
       if (bullet === undefined || bullet == null) {
         return;
       }
   
       bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
       bullet.setScale(0.3);
       bullet.body.velocity.x += 300;
       setTimeout(() => bullet.disableBody(true, true), 2000);
       this.nextFireTime = this.fireRate;
     }
  
  
  generateEnemy(dt) {
    this.nextEnemySpawn -= dt;
    if (this.nextEnemySpawn > 0) {
      return;
    }
    const enemy = this.enemies.getFirstDead();
    if (enemy === undefined || enemy == null) {
      return;
    }
    
    enemy.enableBody(true, 1300, Phaser.Math.Between(50, 450), true, true);
    enemy.setScale(0.3);
    enemy.body.velocity.x -= Phaser.Math.Between(100, 350);
    enemy.play("enemyAnimation");

    this.nextEnemySpawn = this.enemySpawnRate;
  }
     
  fire(dt) {
    this.nextFireTime -= dt;
    if (this.nextFireTime > 0) {
      return;
    }
    const bullet = this.playerBullets.getFirstDead();
    if (bullet === undefined || bullet == null) {
      return;
    }

    bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
    bullet.setScale(0.2);
    bullet.body.velocity.x += 300;
    this.nextFireTime = this.fireRate;
  }
  
  
  playerHitEnemy(player, enemy) {
    console.log('boom')
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!enemy.active) {
      return;
    }
    
    this.playerLives--;
    if (this.playerLives <= 0) {
      this.playerScore = 0;
      this.playerLives = 3;
      this.playerScoreText.setText("Score: " + this.playerScore);
    }
      
    this.playerLivesText.setText("Lives: " + this.playerLives);
    
    
    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
  
    bulletHitEnemy(bullet, enemy) {
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!bullet.active) {
      return;
    }
    bullet.disableBody(true, true);
    bullet.x = -100;
      
    this.playerScore += 100;
    this.playerScoreText.setText("Score: " + this.playerScore);

    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
  
     //End custom functions, NOTE: None of our code should go below this...
   }
   
   var config = {
   type: Phaser.AUTO,
   width: 1280,
   height: 720,
   backgroundColor: "#5DACD8",
   scene: MyGame,
   physics: {
     default: "arcade",
     arcade: {
       gravity: { y: 0 },
       debug: false
     }
   }
   };
   
   
   var game;
   function startGame() {
   if (!game) {
     game = new Phaser.Game(config);
   } else {
     game.start();
   }
   }
   
   function stopGame() {
   if (game) {
     game.destroy(true, false);
     game = null;
   }
   }
`

const KeepingScore = () => (
  <>
    <h1>Keeping Score</h1>
    <p>
      With the ability to fly around and shoot down planes we can now keep track
      of how we are doing. Lets add in a simple way to keep track of player
      scores and lives.
    </p>
    <p>
      Lets add some new variables at the bottom of of variable list for keeping
      track of score and lives, add the following:
    </p>
    <CopyBlock
      text={scoreVariables}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      As usual we need to create something after we make our variable. We are
      going to tell phaser to show our new text variables on the screen. Add the
      following to the bottome of our create method:
    </p>
    <CopyBlock
      text={textSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      You will now have two things displaying at the top of the screen one for
      score and one for lives. However, they dont do anything yet so lets add in
      that logic.
    </p>
    <p>
      Currently nothing happens when the player collides with a plane, so lets
      create a new collision detection function. Add this code snippet inside
      the create function under the overlap function call for bullets and
      enemies:{" "}
    </p>
    <CopyBlock
      text={playerEnemyCol}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we will create a new function that handles when a player crashes into
      a plane. Add the following below our other custom functions:
    </p>
    <CopyBlock
      text={playerHitEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we should see player lives tick down every time we hit an enemy, then
      reset to 3. This will also reset our score, but lets add in the score so
      we can see that now.
    </p>
    <p>
      Inside our bullet hit enemy function we need to add a little bit of logic
      in increase the players score. Just below the line inside the
      bulletHitEnemy function add the following:{" "}
    </p>
    <CopyBlock
      text={bulletHitEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we should see the score increase by 100 everytime we hit an enemy and
      reset to 0 after we lose all our lives.
    </p>

    <br />
    <br />
    <Button type="button" variant="secondary" href="/Sound">
      Next
    </Button>
    <br />
    <br />
    <Accordion flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Code Checkpoint</Accordion.Header>
        <Accordion.Body>
          <CopyBlock
            text={progressSnippet}
            language={"js"}
            showLineNumbers={true}
            theme={dracula}
            codeBlock
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    <br />
    <br />
  </>
)

export default KeepingScore
